/**
 * Created by razial on 30.01.2023
 */

function createPathAnimation(cardView, endPosition, duration) {
    const particles = new cleverapps.Spine(bundles.card.jsons.card_particles_json);
    cardView.addChild(particles);
    particles.setAlignment(cardView.width / 2, cardView.height / 2);
    particles.setVisible(false);

    const path = new cleverapps.Spine(bundles.card.jsons.card_path_json);
    cardView.addChild(path, -2);
    path.setAlignment(cardView.width / 2, cardView.height / 2);
    path.setVisible(false);
    path.setRotation(-90);
    path.setTimeScale(path.getAnimationDuration("animation") / duration);

    return new cc.Spawn(
        new cc.Sequence(
            new cc.CallFunc(() => {
                particles.setVisible(true);
                particles.replaceParentSamePlace(cleverapps.Scenes.GetRunningScene(), { keepRotation: true });
                particles.setAnimation(0, "animation", false);
                particles.setCompleteListenerRemove();
            })
        ),

        new cc.CallFunc(() => {
            path.runAction(new cc.Sequence(
                new cc.CallFunc(() => {
                    path.setVisible(true);
                    path.setAnimation(0, "animation", false);
                }),
                new cc.DelayTime(duration * 0.8),
                new cc.CallFunc(() => {
                    path.replaceParentSamePlace(cleverapps.Scenes.GetRunningScene(), { keepRotation: true, keepScale: true });
                }),
                new cc.DelayTime(duration * 0.2),
                new cc.RemoveSelf()
            ));
        })
    );
}

cleverapps.UI.animateCard = function (options) {
    options = options || {};

    const getTargetPosition = function () {
        let position = options.position;

        if (typeof position === "function") {
            position = position();
        }

        return position.parent.convertToWorldSpace(position.point);
    };

    const movingNode = cleverapps.Scenes.GetMovingNode(options.cardView);
    if (options.zOrder) {
        movingNode.setLocalZOrder(options.zOrder);
    }

    const cardView = options.cardView;

    cardView.realParent = cardView.parent === movingNode ? cardView.realParent : cardView.parent;
    const animationId = cardView.animationId = cardView.animationId + 1 || 1;

    const scale = options.scale || cardView.card.getScale();

    const position = getTargetPosition();
    let duration = options.duration || 0.7;

    let animation = options.animation;

    const isRightDirection = cardView.parent.convertToWorldSpace(cardView).x <= position.x;
    if (animation === cleverapps.UI.animateCard.ANIMATIION_BIT) {
        animation = isRightDirection ? "bit" : "bit2";
    }

    const actions = [];

    cardView.replaceParentSamePlace(movingNode, {
        keepScale: true
    });

    if (animation) {
        const animationTime = options.animationTime || duration;
        actions.push(new cc.CallFunc(() => {
            const spine = cardView.animation;
            spine.setAnimation(0, animation, false);
            let savedTimeScale;
            if (animationTime && animationTime !== spine.getTimeLeft()) {
                savedTimeScale = spine.getTimeScale();
                spine.setTimeScale(spine.getTimeLeft() / animationTime);
            }
            spine.setCompleteListener(() => {
                spine.setCompleteListener();
                if (savedTimeScale) {
                    spine.setTimeScale(savedTimeScale);
                }
                cardView.setIdleAnimation();
            });
        }));
    }

    if (options.delay) {
        actions.push(new cc.DelayTime(options.delay));
    }

    const finalP = movingNode.convertToNodeSpace(position);

    if (options.rotation) {
        const dx = finalP.x - cardView.x;
        const dy = finalP.y - cardView.y;
        cardView.finalRotation = 270 - Math.atan2(dy, dx) * 180 / Math.PI;

        actions.push(new cc.RotateTo(0.1, cardView.finalRotation));
        duration -= 0.1;
    }

    const spawn = [];
    if (options.midpoint) {
        const firstP = movingNode.convertToNodeSpace(cardView.parent.convertToWorldSpace(cardView));
        const secondP = cc.p(firstP.x + options.midpoint.x * (isRightDirection ? 1 : -1), firstP.y + options.midpoint.y);
        spawn.push(new cc.BezierTo(duration, [firstP, secondP, finalP]).easing(options.easing || cc.easeIn(1)));
    } else {
        const move = new cc.MoveTo(duration, finalP);
        spawn.push(options.easing ? move.easing(options.easing) : move);
    }

    if (!options.noAnimateScale) {
        const moveScale = cc.Base.AdjustScaleTo(movingNode, cardView.realParent);

        if (options.dynamicRatioOfParentScale) {
            moveScale.x /= options.dynamicRatioOfParentScale;
            moveScale.y /= options.dynamicRatioOfParentScale;
        }

        spawn.push(cleverapps.UI.animateScale({
            scale: {
                x: (scale.x || scale) / moveScale.x,
                y: (scale.y || scale) / moveScale.y
            },
            duration,
            overScaling: options.overScaling
        }));
    }

    if (options.path) {
        spawn.push(createPathAnimation(cardView, position, duration));
    }

    if (options.rotation) {
        spawn.push(new cc.Sequence(
            new cc.DelayTime(0.8 * duration),
            new cc.Spawn(new cc.RotateTo(0.2 * duration, 0).easing(cc.easeSineInOut()))
        ));
    }

    actions.push(new cc.Spawn(spawn));

    if (options.replaceParentBack !== false) {
        actions.push(new cc.CallFunc(() => {
            if (animationId === cardView.animationId) {
                cardView.replaceParentSamePlace(cardView.realParent);
                cardView.setScale(scale);
            }
        }));
    }

    actions.push(new cc.CallFunc(() => {
        if (cardView.parent) {
            const position = cardView.parent.convertToNodeSpace(getTargetPosition());
            cardView.setAlignment(position);
        }

        if (options.zOrder) {
            movingNode.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 3);
        }
    }));

    return new cc.Sequence(actions);
};

cleverapps.UI.animateCard.ANIMATIION_BIT = "bit";
